import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import { ReactNode } from "react";
import { Image, StyleSheet } from "react-native";
import { NOT_FOUND } from "../../../assets/not-found";
import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../utils";
import BMView from "../../View/BMView";

type Props = {
  query: string;
  isMobile?: boolean;
  noResultCaption?: string;
  NoResultFooterComponent?: (props: { query: string }) => ReactNode;
};

export default function BMDropdownNotFoundOptions({
  query,
  isMobile = false,
  noResultCaption,
  NoResultFooterComponent,
}: Props) {
  const { CorporateGeneralErrorMessage: cr } = useMobileContentResource();
  const styles = createStyles(isMobile);

  const renderNoResultCaption = () =>
    noResultCaption ? (
      <BMText
        style={styles.textAlignCenter}
        variant="paragraphNormal"
        numberOfLines={2}
        ellipsizeMode="tail"
      >
        {noResultCaption}
      </BMText>
    ) : null;

  const renderFooter = () =>
    typeof NoResultFooterComponent === "function" ? (
      <NoResultFooterComponent query={query} />
    ) : null;

  return (
    <BMView
      style={[
        !isMobile ? styles.container : null,
        !isMobile ? styles.marginBottomLG : styles.marginBottomXL5,
      ]}
    >
      <BMView spacing="md" align="center">
        <BMView spacing="sm">
          <BMView
            align="center"
            row={!isMobile}
            spacing={isMobile ? "sm" : "md"}
            justify={isMobile ? "center" : "start"}
          >
            <Image
              source={{ uri: NOT_FOUND }}
              style={styles.notFoundIllustration}
            />
            <BMText variant="titleSmall" numberOfLines={2} ellipsizeMode="tail">
              {formatMessage(cr.noResultFound, { query })}
            </BMText>
          </BMView>
          {renderNoResultCaption()}
        </BMView>
        {renderFooter()}
      </BMView>
    </BMView>
  );
}

function createStyles(isMobile: boolean) {
  return StyleSheet.create({
    container: {
      padding: BMPrimitives.BMSize.md,
    },
    marginBottomXL5: {
      marginBottom: BMPrimitives.BMSize.xl5,
    },
    marginBottomLG: {
      marginBottom: BMPrimitives.BMSize.lg,
    },
    notFoundIllustration: {
      width: isMobile ? 120 : 48,
      height: isMobile ? 120 : 48,
    },
    textAlignCenter: {
      textAlign: "center",
    },
  });
}
